import { render, staticRenderFns } from "./GenericDialog.vue?vue&type=template&id=8b39c6a6&scoped=true&"
import script from "./GenericDialog.vue?vue&type=script&lang=js&"
export * from "./GenericDialog.vue?vue&type=script&lang=js&"
import style0 from "./GenericDialog.vue?vue&type=style&index=0&id=8b39c6a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b39c6a6",
  null
  
)

export default component.exports